import { Outlet } from 'react-router'
import { Grid } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'

import useSharedStyles from '../../utils/shared.styles'
import ErrorBoundary from '../error-boundary'
import Header from '../header'

const RouteWrapper = () => {
  const sharedClasses = useSharedStyles
  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid
          container={true}
          sx={{
            minHeight: '100vh',
            flexDirection: 'column',
          }}
        >
          <Header />
          <Grid container={true} sx={[sharedClasses.centerContentHorizontal, { flexGrow: 1 }]}>
            <Grid
              sx={{
                maxWidth: 'xl',
                flexGrow: 1,
                mb: 8,
                padding: 3,
                minWidth: 0,
              }}
            >
              <Outlet />
            </Grid>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </ErrorBoundary>
  )
}

export default RouteWrapper
